<template>
  <div class="row pt-4" id="app-toolbar">
    <div class="col-md-8 d-flex">
      <div class="btn-group dropdown mr-2">
        <button
          type="button"
          class="step-3 btn btn-info btn-sm dropdown-toggle"
          data-toggle="dropdown"
          title="Set or clear playlists from the selected media"
          ref="setPlaylistsDropdown"
        >
          <i class="fa fa-bars" aria-hidden="true"></i>
          Playlists
        </button>

        <div class="dropdown-menu">
          <form class="px-4 py-3">
            <div class="form-check" v-for="playlist in playlists" :key="playlist.id">
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="'chk_playlist_' + playlist.id"
                name="playlists[]"
                v-model="checkedPlaylists"
                v-bind:value="playlist.id"
              />
              <label
                class="form-check-label"
                v-bind:for="'chk_playlist_'+playlist.id"
              >{{ playlist.name }}</label>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chk_playlist_new"
                  v-model="checkedPlaylists"
                  value="new"
                />
                <label class="custom-control-label" for="chk_playlist_new">
                  <input
                    type="text"
                    class="form-control p-2"
                    id="new_playlist_name"
                    name="new_playlist_name"
                    v-model="newPlaylist"
                    style="min-width: 150px;"
                    placeholder="New Playlist"
                  />
                </label>
              </div>
            </div>
          </form>

          <button @click="setPlaylists" type="submit" class="btn btn-sm btn-info ml-4 mr-2">Save</button>
          <button type="button" class="btn btn-sm btn-warning mr-4" @click="clearPlaylists()">Clear</button>
        </div>
      </div>

      <button class="btn btn-danger btn-sm" type="button" @click="doDelete">
        <i class="fas fa-trash"></i>
        Delete
      </button>
    </div>
  </div>
</template>
<script>
import toast from "@/plugins/toast";
import ApiService from "@/plugins/ApiService";
import swal from "sweetalert2";
import { DISPATCH_DELETE, FETCH_STATION_INFO } from "@/store/action-types";

export default {
  name: "station-media-toolbar",
  props: {
    selectedItems: Array,
  },

  data() {
    return {
      checkedPlaylists: [],
      newPlaylist: "",
      playlists: [],
      batchUrl: "admin/batch-playlist-attach",
    };
  },

  async mounted() {
   await this.getData();
    this.$emit('playlistEvent', this.playlists)
  },

  watch: {
    selectedItems(items) {
      // Get all playlists that are active on ALL selected items.
      let playlistsForItems = _.map(items, (item) => {
        return _.map(item.playlists, "id");
      });

      // Check the checkboxes for those playlists.
      this.checkedPlaylists = _.intersection(...playlistsForItems);
    },
    newPlaylist(text) {
      if (text !== "") {
        if (!this.checkedPlaylists.includes("new")) {
          this.checkedPlaylists.push("new");
        }
      }
    },
  },
  computed: {
    langErrors() {
      return "The request could not be processed.";
    },
  },
  methods: {
    async getData() {
      const res = await ApiService.get(`admin/playlists?station=${this.stationId}&format=true`);
      this.playlists = res.data;
    },

    doDelete() {
      let buttonText = "Delete";

      let numFiles = this.selectedItems.length;


      if (numFiles <= 0) {
          this.notifyNoFiles()
          return
      }
    //   return

      swal.fire({
        text: `About to delete ${numFiles} media files`,
        confirmButtonText: buttonText,
        confirmButtonColor: "#e64942",
        showCancelButton: true,
        focusCancel: true,
      }).then((result) => {
        if (result.value) {

          this.$store.dispatch(DISPATCH_DELETE, 
          {
            url: `admin/files/${this.stationId}/delete_multiple`, 
            items: _.map(this.selectedItems,(item)=> item.id) })
          .then(() =>{
               this.$emit("relist");
          })
         

        }
      });
    },
    doBatch(action, notifyMessage) {
      if (this.selectedItems.all.length) {
        this.notifyPending();

        ApiService.post(this.batchUrl, {
          do: action,
          files: this.selectedItems,
          station: this.stationId
        })
          .then((resp) => {
            this.$emit("relist");

            // if (resp.data.success) {
            //     let allItemNames = _.map(this.selectedItems.all, 'path_short');
            //     //notify('<b>' + notifyMessage + '</b><br>' + allItemNames.join('<br>'), 'success', false);
            //     toast.success('<b>' + notifyMessage + '</b><br>' + allItemNames.join('<br>'))
            // } else {
            //   //  notify('<b>' + this.langErrors + '</b><br>' + resp.data.errors.join('<br>'), 'danger');
            //     toast.error('<b>' + this.langErrors + '</b><br>' + resp.data.errors.join('<br>'), 'danger')
            // }
          })
          .catch((err) => {
            this.handleError(err);
          });
      } else {
        this.notifyNoFiles();
      }
    },
    clearPlaylists() {
      this.checkedPlaylists = [];
      this.newPlaylist = "";

      this.setPlaylists();
    },
    setPlaylists() {

      if (this.selectedItems.length) {
        this.notifyPending();

        ApiService.post(this.batchUrl, {
          do: "playlist",
          playlists: this.checkedPlaylists,
          new_playlist_name: this.newPlaylist,
          tracks: _.map(this.selectedItems, (item) => item.id),
          station: this.stationId
        })
          .then((resp) => {
            // if (resp.data.success) {
            //     if (resp.data.record) {
            // this.$emit('add-playlist', resp.data.record);
            //     }

            //     let notifyMessage = (this.checkedPlaylists.length > 0)
            //         ? 'Playlists updated for selected files:'
            //         : 'Playlists cleared for selected files:';

            //     let allItemNames = _.map(this.selectedItems.all, 'path_short');
            //    // notify('<b>' + notifyMessage + '</b><br>' + allItemNames.join('<br>'), 'success');
            //    toast.success('<b>' + notifyMessage + '</b><br>' + allItemNames.join('<br>'))

            this.checkedPlaylists = [];
            this.newPlaylist = "";
            // } else {
            //    // notify(resp.data.errors.join('<br>'), 'danger');
            //     toast.error(resp.data.errors.join('<br>'))
            // }

            // Refresh station info to update is_playable status
            this.$store.dispatch(FETCH_STATION_INFO, {
              id: this.stationId,
              repeat: false
            });

            this.$emit("relist");
          })
          .catch((err) => {
            this.handleError(err);
          });
      } else {
        this.notifyNoFiles();
      }
    },
    notifyPending() {
      toast.success("<b>" + "Applying changes..." + "</b>");
    },
    notifyNoFiles() {
      toast.error("<b>" + "No files selected." + "</b>", 'error', 'center');
    },
    handleError(err) {
      console.error(err);
      if (err.response.message) {
        toast.error("<b>" + err.response.message + "</b>");
      }
    },
  },
};
</script>
